import { GearSixIcon, HeartIcon } from "@phosphor-icons/react/dist/ssr";
import type { ReactElement } from "react";

const GEAR_ICON_SIZE = 64;
const HEART_ICON_SIZE = 20;

export function MaintenanceIllustration(): ReactElement {
  return (
    <div aria-hidden="true" className="relative size-36 shrink-0 sm:size-44">
      <div className="absolute inset-0 rounded-full border border-dashed border-primary-300" />
      <span className="absolute top-5 right-4 size-2 sm:top-6 sm:right-5 rounded-full bg-secondary-400" />
      <span className="absolute bottom-8 left-0.5 size-1.5 sm:bottom-10 rounded-full bg-primary-400" />
      <div className="absolute inset-6 flex -rotate-6 items-center justify-center rounded-[28px] bg-gradient-to-br from-primary-100 to-primary-200 shadow-[0_16px_32px_-16px_hsl(var(--primary-600)/0.45)] sm:inset-8">
        <GearSixIcon
          size={GEAR_ICON_SIZE}
          weight="duotone"
          className="size-14 rotate-6 text-primary-600 sm:size-16 motion-safe:animate-[spin_24s_linear_infinite]"
        />
      </div>
      <span className="absolute right-4 bottom-5 flex size-9 items-center justify-center rounded-full bg-secondary-100 ring-4 ring-neutral-0 sm:right-6 sm:bottom-7 sm:size-10">
        <HeartIcon size={HEART_ICON_SIZE} weight="duotone" className="text-secondary-400" />
      </span>
    </div>
  );
}
